import { render, staticRenderFns } from "./IndexationRefinement.vue?vue&type=template&id=197a0a32&"
import script from "./IndexationRefinement.vue?vue&type=script&lang=js&"
export * from "./IndexationRefinement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports